<template lang="pug">
.parametros-padrao
    .parametros-padrao__titulo
        h3 {{ $t('configuracaoParametros.listagem.tabela.titulo.padrao') }}
    .parametros-padrao__tabela
        el-table(:data='configuracoes')
            el-table-column(
                prop='nome',
                :label='$t("configuracaoParametros.listagem.tabela.labels.nome")'
            )
            el-table-column(
                prop='distanciaRaioKm',
                :label='$t("configuracaoParametros.listagem.tabela.labels.distancia")'
            )
                template(slot-scope='scope')
                    span {{ formatNumber(scope.row.distanciaRaioKm) }}
            el-table-column(
                prop='percentualCapacidadeProdutiva',
                :label='$t("configuracaoParametros.listagem.tabela.labels.percentual")'
            )
                template(slot-scope='scope')
                    span {{ formatNumber(scope.row.percentualCapacidadeProdutiva) }}%

            el-table-column(
                :label='$t("mensagens.comuns.acoes")',
                width='180',
                align='center'
            )
                .template(slot-scope='scope')
                    el-dropdown.action-button
                        i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-edit',
                                @click.native='editarConfigParam(scope.row.id)'
                            ) {{ $t('mensagens.comuns.editar') }}
                            el-dropdown-item(
                                icon='el-icon-delete',
                                @click.native='confirmarRemocao(scope.row.id)'
                            ) {{ $t('mensagens.comuns.excluir') }}

            template(slot='empty')
                el-empty(
                    :description='$t("configuracaoParametros.listagem.tabela.semDados")'
                )
</template>

<script>
import services from '@/services/ConfiguracaoRastreabilidadeService';
import formatters from '@/utils/formatters';

export default {
    name: 'ParametrosPadrao',
    data() {
        return {
            filtro: {
                nome: '',
                tipoConfiguracaoRastreabilidade: 'PADRAO'
            },
            configuracoes: [],
            pageable: {
                page: 0,
                size: 10
            }
        };
    },
    mounted() {
        this.buscarConfiguracoes();
    },
    methods: {
        buscarConfiguracoes() {
            return services
                .buscarConfiguracoesRastreabilidadePorFiltro(
                    this.filtro,
                    this.pageable
                )
                .then(response => {
                    this.configuracoes = response.data.configuracoes;
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.listagem.erroBuscarConfiguracoesRastreabilidade'
                        )
                    );
                });
        },
        confirmarRemocao(id) {
            this.$messageBox
                .confirm(
                    this.$t(
                        'mensagens.operacao.formularioPessoa.confirmaRemoverRegistro'
                    ),
                    this.$t('mensagens.comuns.confirmar'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                )
                .then(() => {
                    this.removerConfiguracao(id);
                });
        },
        editarConfigParam(id) {
            this.$router.push({
                name: 'ParametrosPadraoFormulario',
                params: {
                    idConfiguracaoRastreabilidade: id
                }
            });
        },
        removerConfiguracao(id) {
            return services
                .excluirConfiguracaoRastreabilidade(id)
                .then(() => {
                    this.buscarConfiguracoes();
                    this.$notify.success(
                        this.$t(
                            'configuracaoParametros.sucesso.sucessoExcluirDados'
                        )
                    );
                })
                .catch(() => {
                    if (id === 1) {
                        return;
                    }
                    this.$notify.error(
                        this.$t('configuracaoParametros.erro.erroExcluirDados')
                    );
                });
        },
        goToCadastroConfiguracaoParametros() {
            this.$router.push({
                name: 'CadastroConfiguracaoParametros',
                params: {
                    tipoCadastro: {
                        nome: this.activeTab.toLocaleLowerCase(),
                        codigo: this.activeTab
                    }
                }
            });
        },
        formatNumber(number) {
            return number ? formatters.formatNumber(number, 2) : '-';
        }
    }
};
</script>

<style lang="scss">
.parametros-padrao {
    &__titulo {
        margin-top: 20px;
    }

    &__tabela {
        padding: 4px 26px 0 26px;
        margin-top: 20px;
        background-color: var(--white);
        border-radius: $default-border-radius;
    }
}
</style>
